// Expected backend response formats:
// 1. Laravel/Symfony: { message: "Error text", error: "detailed error" }
// 2. Symfony 422: { error: "JSON with error_message and error fields" }
// 3. Symfony 403: { error: "JSON with is_external_api_error: true" }
// 4. AxiosError: { response: { status: 4xx/5xx, data: {...} } }

export const getDefaultMessage = (err) => {
    if (err.response && err.response.status) {
        const status = err.response.data?.status || err.response.status;
        
        switch (true) {
            case status >= 400 && status < 500:
                const clientErrorMessages = {
                    400: 'Bad Request - Invalid data provided',
                    401: 'Unauthorized - Please check your credentials',
                    403: 'Forbidden - Access denied',
                    404: 'Not Found - Resource not available',
                    422: 'Validation Error - Invalid input data'
                };
                return clientErrorMessages[status] || `Client Error (${status})`;
                
            case status >= 500:
                return 'Internal Server Error - Please try again later';
                
            default:
                return 'An error occurred';
        }
    }
    
    if (err.code === 'ERR_NETWORK') {
        return 'Network Error';
    } else if (err.code === 'ERR_TIMEOUT') {
        return 'Request Timeout';
    } else if (err.code === 'ERR_CANCELED') {
        return 'Request Canceled';
    } else {
        return 'Request Failed';
    }
};

export const process = (err, enqueueSnackbar) => {
    if (!err || !err.response) {
        output({ message: 'Expected AxiosError', trace: err }, enqueueSnackbar);
        return;
    }
    
    const data = err?.response?.data;
    
    output({
        message: data?.message || data?.error || getDefaultMessage(err),
        trace: data?.details || err
    }, enqueueSnackbar);
};

export const output = (json, enqueueSnackbar) => {
    const { message, trace } = json;
    
    if (message === null) {
        return;
    }
    
    if (typeof message === 'string') {
        enqueueSnackbar(message, { variant: 'error' });
    } else {
        console.error({ message: message, trace: trace });
    }
    
    if (trace !== null) {
        console.error(trace);
    }
};